import { useEffect, useState } from 'react';
import congratulations from '../../assets/svgs/Congratulations.svg';
import logo from '../../assets/svgs/Rehabitairelogo.svg';
import { useNavigate } from 'react-router';
import PrimaryButton from '../../components/primary-button';
import {
  clearLatestRecordingPayload,
  createRecordingFileName,
  getLatestRecordingPayload,
} from '../exercise/hooks/use-recording-video';
import tw from 'twin.macro';

import 'twin.macro';

const PostPerformance = () => {
  const navigate = useNavigate();
  const [hasRecordedVideo, setHasRecordedVideo] = useState(false);

  useEffect(() => {
    let isMounted = true;
    let timeoutId = null;
    const MAX_WAIT_MS = 60_000;
    const POLL_INTERVAL_MS = 1_000;
    const startedAt = Date.now();

    const poll = async () => {
      if (!isMounted) return;

      try {
        const payload = await getLatestRecordingPayload();
        if (!isMounted) return;

        if (payload?.blob) {
          setHasRecordedVideo(true);
          return;
        }
      } catch (error) {
        console.error('Failed to load recorded video from IndexedDB:', error);
      }

      if (Date.now() - startedAt < MAX_WAIT_MS) {
        timeoutId = window.setTimeout(poll, POLL_INTERVAL_MS);
      }
    };

    poll();

    return () => {
      isMounted = false;
      if (timeoutId !== null) {
        window.clearTimeout(timeoutId);
      }
    };
  }, []);

  const handleDownloadVideo = async () => {
    const payload = await getLatestRecordingPayload();
    if (!payload?.blob) {
      return;
    }

    const fileName = createRecordingFileName(payload.sessionId, Date.now());

    const url = URL.createObjectURL(payload.blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = fileName;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    window.setTimeout(() => URL.revokeObjectURL(url), 1000);
  };

  const handleExitDemo = async () => {
    await clearLatestRecordingPayload();
    localStorage.removeItem('latestRecordingStartedAt');
    navigate('/motion-caption', { replace: true });
  };

  return (
    <div tw="bg-[#EFF4D7] h-screen w-screen relative grid items-center">
      <div tw="fixed top-0 p-8">
        <img loading="lazy" decoding="async" src={logo} alt="logo" />
      </div>
      <div tw="bg-white w-[300px] md:w-[60vw] min-h-[500px] rounded-[10px] justify-self-center p-[1.9em]">
        <div tw="flex justify-center items-center">
          <img loading="lazy" decoding="async" src={congratulations} alt="congratulations" />
        </div>
        <div tw="text-center w-full mt-[2.3em] grid gap-2">
          <p tw="text-[1.4em] font-[600]">Congratulations on Completing your Session!</p>
          <p tw="text-[0.8em] text-[#656565]">
            You’ve just finished Rehabitaire’s demo. The full version is currently in development
            and will be available soon.
          </p>
          <div tw="mt-2 flex flex-col md:flex-row items-center justify-center gap-3">
            {hasRecordedVideo && (
              <PrimaryButton
                text="Download video"
                type="button"
                otherStyle={tw`w-[220px]! px-[30px]! py-[8px]! font-[bold]! whitespace-nowrap`}
                handelClick={handleDownloadVideo}
              />
            )}
            <PrimaryButton
              text="Exit demo"
              type="button"
              otherStyle={tw`w-[220px]! px-[30px]! py-[8px]! font-[bold]! whitespace-nowrap`}
              handelClick={handleExitDemo}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PostPerformance;
